export const getAppTitle = (app, suffix) => {
  if (app && app.name && suffix) {
    return `${app.name} - ${suffix}`
  }

  return app ? app.name || 'Untitled' : 'Loading...'
}
